import { FC } from "react";
import { Col, Row, Typography } from "antd";

import styles from "./KPI.module.less";

const { Text } = Typography;

export interface KPIProps {
  /**
   * KPI name
   */
  name: string;
  /**
   * acquisition method
   */
  acquisitionMethod?: string;
}

/**
 * KPI component
 * @param name
 * @param acquisitionMethod
 */
const KPI: FC<KPIProps> = ({ name, acquisitionMethod }) => {
  return (
    <Row gutter={[0, 8]}>
      <Col span={24}>
        <Text>{name}</Text>
      </Col>
      <Col span={24}>
        <Text type="secondary" className={styles.Acquisition}>
          {acquisitionMethod}
        </Text>
      </Col>
    </Row>
  );
};

export default KPI;
